var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 280,
    height: 280,
    viewBox: "0 0 280 280",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_247_29)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M122.221 11.2889C133.072 4.39881 146.928 4.3988 157.779 11.2889L188.343 30.6962C190.528 32.0838 192.868 33.2107 195.316 34.0541L229.545 45.8499C241.698 50.0378 250.337 60.8703 251.715 73.65L255.599 109.646C255.876 112.22 256.454 114.752 257.321 117.191L269.44 151.308C273.743 163.42 270.66 176.928 261.528 185.974L235.806 211.453C233.967 213.275 232.347 215.306 230.981 217.504L211.864 248.251C205.077 259.167 192.594 265.178 179.827 263.679L143.87 259.455C141.299 259.153 138.701 259.153 136.13 259.455L100.173 263.679C87.4064 265.178 74.9233 259.167 68.1362 248.251L49.0193 217.504C47.6525 215.306 46.0331 213.275 44.194 211.453L18.4722 185.974C9.34015 176.928 6.25707 163.42 10.5598 151.308L22.6793 117.191C23.5459 114.752 24.1238 112.22 24.4015 109.646L28.2847 73.65C29.6634 60.8703 38.302 50.0378 50.4545 45.8499L84.6842 34.0541C87.1316 33.2107 89.4717 32.0838 91.657 30.6962L122.221 11.2889Z",
    fill: "#0F0B0F"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M108.939 162.432C108.939 161.752 108.672 161.158 108.137 160.65C107.616 160.148 107.009 159.897 106.315 159.897H103.87V164.967H106.315C107.015 164.967 107.626 164.716 108.147 164.215C108.675 163.706 108.939 163.112 108.939 162.432ZM113.494 162.432C113.494 164.327 112.762 165.938 111.296 167.264C109.89 168.552 108.23 169.195 106.315 169.195H99.1367V155.679H106.315C108.217 155.679 109.877 156.32 111.296 157.6C112.762 158.94 113.494 160.551 113.494 162.432Z",
    fill: "url(#paint0_linear_247_29)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M114.346 169.195V155.679H127.862V159.897H119.415V160.66H124.485V164.215H119.415V164.967H127.862V169.195H114.346Z",
    fill: "url(#paint1_linear_247_29)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M140.377 169.195H132.268L128.723 155.679H133.961L136.328 164.68L138.694 155.679H143.932L140.377 169.195Z",
    fill: "url(#paint2_linear_247_29)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M144.784 169.195V155.679H149.853V169.195H144.784Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M157.884 169.195C155.969 169.195 154.309 168.552 152.903 167.264C151.438 165.938 150.705 164.327 150.705 162.432C150.705 160.551 151.438 158.94 152.903 157.6C154.322 156.32 155.983 155.679 157.884 155.679C159.745 155.679 161.386 156.293 162.805 157.521L159.706 160.61C159.158 160.135 158.55 159.897 157.884 159.897C157.184 159.897 156.573 160.148 156.052 160.65C155.524 161.158 155.26 161.752 155.26 162.432C155.26 163.119 155.52 163.713 156.042 164.215C156.563 164.716 157.177 164.967 157.884 164.967H159.993V162.432H165.062V169.195H157.884Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M175.202 169.195C175.149 167.736 174.796 166.462 174.142 165.373C173.363 164.046 172.311 163.35 170.984 163.284V169.195H165.914V155.679H165.973C167.868 155.679 169.594 156.006 171.152 156.66C172.908 157.399 174.258 158.478 175.202 159.897V155.679H180.272V169.195H175.202Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M101.901 177.85V178.433H100.249V177.85H101.901ZM100.45 174.626V178.433H99.7494V174.626H100.45ZM101.679 176.19V176.757H100.249V176.19H101.679ZM101.891 174.626V175.212H100.249V174.626H101.891ZM108.927 174.626L109.512 175.941L110.074 174.626H110.856L109.92 176.511L110.875 178.433H110.067L109.481 177.092L108.898 178.433H108.106L109.071 176.498L108.127 174.626H108.927ZM118.535 177.058H117.743V176.472H118.533C118.655 176.472 118.752 176.447 118.826 176.396C118.901 176.344 118.955 176.272 118.988 176.179C119.023 176.087 119.04 175.982 119.04 175.866C119.04 175.752 119.023 175.646 118.988 175.547C118.955 175.445 118.901 175.364 118.826 175.303C118.752 175.242 118.656 175.212 118.535 175.212H117.955V178.433H117.257V174.626H118.535C118.788 174.626 119.005 174.679 119.186 174.786C119.368 174.892 119.506 175.038 119.602 175.225C119.7 175.41 119.749 175.621 119.749 175.86C119.749 176.106 119.7 176.319 119.602 176.498C119.505 176.676 119.365 176.814 119.184 176.911C119.004 177.009 118.788 177.058 118.535 177.058ZM128.379 177.85V178.433H126.727V177.85H128.379ZM126.928 174.626V178.433H126.228V174.626H126.928ZM128.157 176.19V176.757H126.727V176.19H128.157ZM128.369 174.626V175.212H126.727V174.626H128.369ZM134.809 174.626H135.993C136.246 174.626 136.461 174.67 136.639 174.757C136.817 174.844 136.952 174.973 137.044 175.144C137.138 175.315 137.186 175.525 137.186 175.774C137.186 175.973 137.157 176.145 137.099 176.292C137.044 176.436 136.963 176.557 136.859 176.655C136.756 176.753 136.631 176.828 136.485 176.883L136.273 177.003H135.293L135.29 176.42H135.978C136.091 176.42 136.185 176.394 136.26 176.344C136.337 176.293 136.393 176.224 136.43 176.135C136.468 176.044 136.488 175.94 136.488 175.824C136.488 175.696 136.47 175.588 136.435 175.497C136.402 175.404 136.349 175.334 136.276 175.285C136.204 175.236 136.11 175.212 135.993 175.212H135.51V178.433H134.809V174.626ZM136.561 178.433L135.847 176.728H136.582L137.308 178.396V178.433H136.561ZM144.415 174.626V178.433H143.72V174.626H144.415ZM153.206 177.85V178.433H151.553V177.85H153.206ZM151.755 174.626V178.433H151.054V174.626H151.755ZM152.983 176.19V176.757H151.553V176.19H152.983ZM153.195 174.626V175.212H151.553V174.626H153.195ZM162.255 174.626V178.433H161.572L160.302 175.926V178.433H159.633V174.626H160.304L161.585 177.157V174.626H162.255ZM170.7 177.178H171.398C171.386 177.459 171.328 177.696 171.226 177.892C171.124 178.085 170.979 178.232 170.789 178.334C170.601 178.435 170.372 178.485 170.101 178.485C169.896 178.485 169.712 178.449 169.55 178.378C169.388 178.305 169.25 178.199 169.137 178.062C169.025 177.924 168.94 177.755 168.88 177.554C168.823 177.352 168.794 177.121 168.794 176.862V176.2C168.794 175.94 168.825 175.71 168.886 175.507C168.947 175.305 169.034 175.134 169.147 174.995C169.262 174.855 169.402 174.75 169.565 174.679C169.729 174.607 169.914 174.571 170.12 174.571C170.392 174.571 170.619 174.623 170.802 174.726C170.985 174.828 171.126 174.979 171.226 175.178C171.325 175.375 171.383 175.615 171.401 175.899H170.703C170.696 175.715 170.673 175.568 170.635 175.46C170.596 175.35 170.536 175.272 170.454 175.225C170.372 175.178 170.261 175.154 170.12 175.154C170.01 175.154 169.915 175.174 169.835 175.215C169.755 175.255 169.689 175.317 169.639 175.403C169.588 175.486 169.551 175.594 169.526 175.724C169.502 175.855 169.49 176.012 169.49 176.195V176.862C169.49 177.038 169.5 177.191 169.521 177.322C169.542 177.452 169.575 177.561 169.62 177.649C169.667 177.734 169.73 177.798 169.809 177.842C169.887 177.884 169.985 177.905 170.101 177.905C170.243 177.905 170.355 177.884 170.439 177.842C170.522 177.798 170.584 177.724 170.624 177.62C170.666 177.513 170.691 177.366 170.7 177.178ZM180.008 177.85V178.433H178.356V177.85H180.008ZM178.557 174.626V178.433H177.856V174.626H178.557ZM179.786 176.19V176.757H178.356V176.19H179.786ZM179.998 174.626V175.212H178.356V174.626H179.998Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M159.222 145.694L151.827 136.302L144.433 145.694H123.415L141.302 122.947L123.415 100.234H144.433L151.827 109.593L159.222 100.234H180.239L162.353 122.947L180.239 145.694H159.222Z",
    fill: "white"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_247_29)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M132.104 122.945C132.104 120.658 131.205 118.66 129.406 116.951C127.653 115.264 125.61 114.42 123.279 114.42H115.054V131.47H123.279C125.632 131.47 127.686 130.626 129.44 128.939C131.216 127.23 132.104 125.232 132.104 122.945ZM147.422 122.945C147.422 129.316 144.958 134.733 140.029 139.195C135.301 143.524 129.717 145.689 123.279 145.689H99.1367V100.234H123.279C129.673 100.234 135.256 102.388 140.029 106.695C144.958 111.201 147.422 116.618 147.422 122.945Z",
    fill: "url(#paint3_linear_247_29)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_247_29",
    x: 8.64551,
    y: 6.12134,
    width: 262.709,
    height: 260.664,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.87923
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.99758
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0 0 0 0 0 0.96 0 0 0 0.86 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_247_29"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_247_29",
    x: 95.7574,
    y: 95.9334,
    width: 58.1159,
    height: 55.2853,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.53605,
    dy: 0.614422
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.45769
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_247_29"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_247_29",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_247_29",
    x1: 99.1367,
    y1: 176.737,
    x2: 180.632,
    y2: 176.737,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AD00FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0099"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_247_29",
    x1: 99.1367,
    y1: 176.737,
    x2: 180.632,
    y2: 176.737,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AD00FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0099"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_247_29",
    x1: 99.1367,
    y1: 176.737,
    x2: 180.632,
    y2: 176.737,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AD00FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0099"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_247_29",
    x1: 99.1367,
    y1: 171.053,
    x2: 147.637,
    y2: 171.053,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AD00FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0099"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.b13203be6d10483eefd89e2d317ef5ea.svg";
export { ForwardRef as ReactComponent };